import React, { useContext, useEffect, useRef, useState } from "react";
import "./Remote.css";
import EquipmentButtonIcons from "../../../constants/EquipmentButtonIcon";
import { AllEquipmentButton } from "../../../api/api";
import { Context } from "../../../context/Context";

const Input = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  data,
  setData,
}) => {
  const { setIsLoading, equipmentButtons } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id),
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickButton = (button, icon) => {
    setSelectedButton({
      id: button.id,
      icon,
      state:
        selectedButton && selectedButton.id == button.id
          ? selectedButton.state
            ? 0
            : 1
          : 1,
    });
  };

  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.id);
    let data1 = button.digit + 13;
    let data2 = selectedButton.state;
    setData({
      icon: selectedButton.icon,
      name: button.name,
      data: [2, data1, data2],
      type: 9998,
      device: button.device,
    });
    setSelectedButton(null);
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      let iconPath = "/assets/img/custom-equipment-button/19.png";
      let iconId = 19;
      if (button.icon) {
        let buttonIcon = EquipmentButtonIcons.find(
          (icon) => icon.id == button.icon,
        );
        iconPath = buttonIcon.path;
        iconId = buttonIcon.id;
      }
      return (
        <div
          className="remote"
          onClick={() => handleClickButton(button, iconId)}
        >
          <div className="icon-part">
            <img src={iconPath} alt="" />
          </div>
          <div
            className={
              selectedButton && selectedButton.id == button.id
                ? selectedButton.state
                  ? "status-part bg-success"
                  : "status-part bg-danger"
                : "status-part"
            }
          ></div>
          <div className="info-part">
            <p className="text-center p-0 m-0 d-block">{button.name}</p>
            <p className="text-center p-0 m-0">
              {button.digit <= 11
                ? `i${button.digit + 1}`
                : `s${button.digit - 11}`}{" "}
              - S/{button?.device?.serial}
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3"
        style={{ zIndex: 1, top: "0" }}
      >
        <h4>{buttons?.[0]?.equipment?.name ?? ""}</h4>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body">
        <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">{renderButtons()}</div>
      </div>
    </div>
  );
};

export default React.memo(Input);
